export function parseNumberOrZero(rawValue: string | undefined): number {
  const parsed = Number(rawValue);
  return Number.isNaN(parsed) ? 0 : parsed;
}
